'use client'

import { useGetCompanyProductsQuery } from '@/app/globalRedux/api/filter/companySearchSlice'
import {
  addOrRemoveCompanyLocation,
  addOrRemoveCompanyLocationContinents,
  setCompanyLocation,
} from '@/app/globalRedux/filter/commonFilter'
import {
  addOrRemoveTlProductFilterSelectedProduct,
  Product,
  setTlProductSelectAllProducts,
} from '@/app/globalRedux/filter/productFilter'
import { RootState } from '@/app/globalRedux/store'
import { useTranslation } from '@/app/i18n/client'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import SearchIcon from '@mui/icons-material/Search'
import { InputAdornment, TextField } from '@mui/material'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import CompanyLocationFilter from '../CommonFilters/CompanyLocationFilter'
import { usePageNumberUpdator } from '@/app/hooks/usePageParamUpdater'

const ProductTransportLogistics = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const goToPage = usePageNumberUpdator()

  const productFilter = useSelector((state: RootState) => state.productFilter)
  const [productText, setProductText] = useState<string>('')

  const { data: productData = [] } = useGetCompanyProductsQuery<{
    data: Product[]
    isLoading: boolean
    isError: boolean
  }>(productFilter.sector)

  const commonFilter = useSelector((state: RootState) => state.commonFilter)
  const [companyLocation, setCompanyLocationText] = useState<string>('')

  useEffect(() => {
    setCompanyLocationText('')
  }, [productFilter?.clearFilter])

  return (
    <div>
      {/* Products */}
      <div className="shadow-[0_0_3px_0_rgba(0,0,0,0.06)] bg-neutral-50 border border-solid border-[#ebebeb] mt-[20px] rounded-[4px] mobile:mt-[10px]">
        <Accordion type="single" collapsible defaultValue="products">
          <AccordionItem value="products">
            <AccordionTrigger className="text-[18px] font-semibold text-[#222] pb-[0px]">
              {t('Product')}
            </AccordionTrigger>
            <AccordionContent>
              <TextField
                className=" w-[100%]"
                value={productText}
                onChange={(event) => {
                  setProductText(event?.target?.value)
                }}
                size="small"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" className="ml-[10px] ">
                      <SearchIcon className="!w-[17.6px] !h-[17.6px]" />
                    </InputAdornment>
                  ),
                }}
                placeholder={t('Search Products')}
              />
              <div className="flex flex-col  gap-[8px]  max-h-[200px] overflow-y-scroll !mt-[10px] ">
                <div className="flex items-center gap-2">
                  <Checkbox
                    checked={
                      productFilter?.productFilterTlSelectedProducts?.length ===
                      productData?.length
                    }
                    id="select-all-products"
                    className="border-2 border-input"
                    onClick={() => {
                      dispatch(setTlProductSelectAllProducts(productData ?? []))
                      goToPage({ newPageNo: 1 })
                    }}
                  />
                  <Label
                    htmlFor="select-all-products"
                    className="text-sm not-italic leading-[normal] tracking-[normal] text-left text-[#6f6f6f]"
                  >
                    {t('Select All Products')}
                  </Label>
                </div>
                {productData
                  ?.filter((item) =>
                    item?.name
                      ?.toLowerCase()
                      .includes(productText?.toLowerCase())
                  )

                  ?.map((product: Product) => (
                    <div
                      className=" flex flex-row items-center gap-2 "
                      key={product?.name + 'list'}
                    >
                      <Checkbox
                        checked={productFilter.productFilterTlSelectedProducts.some(
                          (p) => p.id === product?.id
                        )}
                        id={product?.name}
                        className="border-2 border-input"
                        onClick={() => {
                          dispatch(
                            addOrRemoveTlProductFilterSelectedProduct(product)
                          )
                          goToPage({ newPageNo: 1 })
                        }}
                      />
                      <Label
                        htmlFor={product?.name}
                        className="  cursor-pointer text-sm  not-italic leading-[normal] tracking-[normal] text-left text-[#6f6f6f]"
                      >
                        {product?.name}
                      </Label>
                    </div>
                  ))}
              </div>
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>

      {/* Company Location */}

      <CompanyLocationFilter
        searchTitle={'Company Location'}
        locationText={companyLocation}
        setLocationText={setCompanyLocationText}
        continentSelectedList={commonFilter?.companyLocationContinents}
        countrySelectedList={commonFilter?.companyLocation}
        setWholeLocation={setCompanyLocation}
        addOrRemoveSelectedCountryList={addOrRemoveCompanyLocation}
        addOrRemoveSelectedContinentList={addOrRemoveCompanyLocationContinents}
      />
    </div>
  )
}

export default ProductTransportLogistics
